import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import SolarIcon from 'components/icons/SolarIcon';
import EToolTip from 'components/others/EToolTip';
import spinnerTitle from 'components/others/spinnerTitle';

interface ReportExportButtonProps {
    disabled?: boolean;
    loading?: boolean;
    onClick: () => void;
}

const ReportExportButton = ({ disabled, loading = false, onClick }: ReportExportButtonProps) => {
    const { t } = useTranslation(['Reports']);

    return (
        <EToolTip title={t('export.toolHint')}>
            <span className="d-inline-block">
                <Button
                    className="fs-14 px-2 toolbar-icon-btn"
                    size="sm"
                    variant="secondary"
                    disabled={disabled || loading}
                    aria-busy={loading}
                    aria-label={t('export.tool')}
                    onClick={(e) => {
                        e.currentTarget.blur();
                        onClick();
                    }}
                >
                    {spinnerTitle(<SolarIcon name="file-earmark-excel" className="fs-14 p-0" />, loading, '')}
                </Button>
            </span>
        </EToolTip>
    );
};

export default ReportExportButton;
